import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Pagination, PaginationItem, PaginationLink} from 'reactstrap';

class Pages extends Component {
    state = {
        listPages: []
    }

    componentDidMount() {
        this.setListPages();
    }

    componentDidUpdate(prevProps) {
        if (this.props.pages.maxPage !== prevProps.pages.maxPage) {
            this.setListPages();
        }
    }

    setListPages = () => {
        const {page, maxPage} = this.props.pages;
        const listPages = [];

        for (let i = page - 3; i <= page + 3; i++) {
            if (i > 0 && i <= maxPage) {
                listPages.push(i);
            }
        }

        this.setState({
            listPages
        });
    }

    goToPage = (index) => () => {
        const {pages, handleGoToPage} = this.props;
        const {page, maxPage} = pages;
        if (page > 0 && index !== page && page <= maxPage) {
            handleGoToPage(index);
        }
    }

    nextPage = () => {
        const {pages, handleGoToPage} = this.props;
        const {page, maxPage} = pages;
        const newPage = page + 1;
        if (newPage <= maxPage) {
            handleGoToPage(newPage);
        }
    }

    previousPage = () => {
        const {pages, handleGoToPage} = this.props;
        const {page} = pages;
        const newPage = page - 1;
        if (newPage > 0) {
            handleGoToPage(newPage);
        }
    }

    render() {
        const {pages} = this.props;
        const {page, maxPage} = pages;
        const {listPages} = this.state;
        if (maxPage === 1) {
            return ('');
        }

        return (
            <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={page === 1} onClick={this.previousPage}>
                    <PaginationLink previous/>
                </PaginationItem>

                {
                    listPages.map((item, index) => {
                        return (
                            <PaginationItem active={item === page} key={index} onClick={this.goToPage(index + 1)}>
                                <PaginationLink>
                                    {item}
                                </PaginationLink>
                            </PaginationItem>
                        );
                    })
                }

                <PaginationItem onClick={this.nextPage} disabled={page === maxPage}>
                    <PaginationLink next/>
                </PaginationItem>
            </Pagination>
        );
    }
}

Pages.propTypes = {
    pages: propTypes.object.isRequired,
    handleGoToPage: propTypes.func.isRequired
}

export default Pages;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/pagination/Pages.js